<template>
        <div class="head">
            <el-image style="width:100%;height:100%"  :src="img"></el-image>
            <div class="head_flex">
                <el-image style="width:40%;height:40%"  :src="phone"></el-image>
                <div>
                    <div class="head_top">营销运营平台</div>
                    <div class="head_content">
                        公司自研充值运营管理系统，能实现自动化接入、联调等接入管理；实时对订单进行监控、异常处理、分发人工干预等；同时实现自动化账单生成、导出，实时账务余额查询等财务管理；公司维护着跟三大运营商实时同步的行业最全最及时分省维护信息，保障终端客户有最及时提醒和产品上下架；还投入核心技术，开发了智能化运营，根据通道质量实时智能调配订单流转分发策略的OIDS系统，实时监控通道和客户充值质量数据，精确到秒为单位；实现海量各类通道资源接入，以及接入后订单最优分发，以保障最佳用户体验和给予终端客户最佳价值让利。
                    </div>
                        <div class="head_border"><span style="color: #336EFA;">全覆盖：</span> 三网全覆盖、移动、联通、电信</div>
                        <div class="head_border_right">随时查看数据、财务对账、数据分析、数据报表 数据可视化 <span style="color: #336EFA;">数据可视化</span></div>
                        <div class="head_border"> <span style="color: #336EFA;">精细化运营：</span>聚焦核心业务赋能数据增长</div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    data(){
        return{
            img:require("./../assets/endProduct.png"),
            phone:require("./../assets/phone.png")
        }
    }
}
</script>

<style scoped>
  /* @import "./../style/index.scss"; */
    .head{
    background:linear-gradient(#f4f8ff,#f4f8ff,#bdd0fa77);
    }
    .head_flex{
        display: flex;
        justify-content: space-evenly;
        padding:90px 0 90px 0;
    }
    .head_top{
        color: #336EFA;
        font-size: 28px;
        padding-bottom: 15px;
        font-family: "ku";
    }
    .head_content{
        width: 550px;
        font-size: 13px;
        color: #336EFA;
        font-family: "黑体";
        line-height: 25px;
    }
    .head_border{
        border-top:3px solid red; 
        border-bottom:3px solid red; 
        border-left: 0px !important;
        border-image:linear-gradient(to right,#336EFA,transparent,transparent ) 1 10;
        padding: 10px;
        color: #336ffa91;
        margin-top: 25px;
        font-size: 18px;
        font-family: "ku";
    }
    .head_border_right{
         border-top:3px solid red; 
        border-bottom:3px solid red;
        border-right: 0px !important;
        border-image:linear-gradient(to left,#336EFA,transparent,transparent ) 1 10;
        color: #336ffa91;
        padding: 10px;
        margin-top: 25px;
        font-size: 18px;
        font-family: "ku";
    }
</style>


// WEBPACK FOOTER //
// src/components/product.vue